import { Box, Grid, LinearProgress, Paper, IconButton, Tooltip, Button } from '@mui/material';
import {
  DataGridProProps,
  GridColumnOrderChangeParams,
  GridColumnVisibilityModel,
  GridRowClassNameParams,
  GridSortModel,
  MuiEvent,
  useGridApiRef,
  GridPagination,
} from '@mui/x-data-grid-pro';
import { DataGridPro } from '@mui/x-data-grid-pro/DataGridPro/DataGridPro';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
// import { clearSelectedFilterAction, selectFilterAction } from 'store/actions/filterActions';

import { changePageSizeAction, changePageAction, sortKpimetricGridAction } from 'store/actions/dashboardActions';
import { kpiMetricColumnsFields, useColumns } from './KpiMetricsService';
import { useTranslation } from 'react-i18next';

import { DownloadIcon } from 'components/CustomIcons';

type KpiMetricsProps = {
  FilterKpiMetric: any;
  dashboardKpiGridData: any[];
  FilterNeeded: boolean;
  isLoading?: boolean;
  notaskImg?: string;
  onDownloadXlsx?: () => void;
  showDownload?: boolean;
};

const KpiMetricsTable = (props: KpiMetricsProps) => {
  const { FilterKpiMetric, dashboardKpiGridData, isLoading: loadingProp, onDownloadXlsx, showDownload } = props;
  const { dashboard } = useSelector((state) => state);
  const { loadings } = useSelector((state) => state);

  const kpimetric_type = FilterKpiMetric?.page_title ?? 'Workunit';
  const columns = useColumns(kpiMetricColumnsFields, kpimetric_type);
  // Specify which column fields should be sortable. Update this list as needed.
  const sortableFields: string[] = [
    'id',
    'name_spec',
    'ref_spec',
    'client_fullname',
    'scope_id',
    'price',
    'workload',
    'forecast_date',
    'status',
    'mission_advancement_id',
    'delivery_manager_fullname',
    // 'bm_id',
    'order_id',
    'affair_otp',
    'consultant_fullname',
    'affair_name',
    // 'customer',
    // 'bu',
    'rating',
    'workunit_name',
    'workunit_reference',
  ];

  const metricTooltip = FilterKpiMetric?.page_title ? `Export ${FilterKpiMetric.page_title} Excel` : 'Export Excel';

  const dataGridColumns = (columns[FilterKpiMetric?.page_title] ?? []).map((col) => {
    const isSortable = sortableFields.includes(String(col.field));
    return {
      ...col,
      sortable: isSortable,
      // v5 Specific: prevents the sorting icon from being "reserved" in the layout
      disableColumnMenu: true, // Hide the 3-dot menu where sort also lives
      sortingOrder: isSortable ? ['asc', 'desc'] : [],
      headerName: col.headerName,
    };
  });

  const { currentPage, pageSize } = dashboard;

  const { totalItems } = dashboard?.pageHandler;
  const { dispatch } = useAppState();
  const [t] = useTranslation();
  //  const order = useSelector((state) => state?.deliverable?.order);
  const apiRef = useGridApiRef();

  const [currentPageVal, setCurrentPageVal] = useState(currentPage);

  // useEffect(() => {}, [FilterKpiMetric]);

  // useLayoutEffect(() => {
  //   dispatch(clearSelectedFilterAction());
  //   return () => {
  //     dispatch(clearSelectedFilterAction());
  //   };
  // }, []);

  const onPageSizeChange = (pageSize: number) => {
    dispatch(changePageSizeAction(pageSize));
    // dispatch(filterTotalFlagAction(true));
  };

  const onPageChange = (page: number) => {
    setCurrentPageVal(page);
    dispatch(changePageAction(Number(page)));
    // setTimeout(() => {
    //   dispatch(filterTotalFlagAction(true));
    // }, 500);
  };

  // useEffect(() => {
  //   // const handler = setTimeout(() => {
  //   dispatch(changePageAction(Number(currentPageVal)));
  //   dispatch(filterTotalFlagAction(true));
  //   // }, 500);

  //   // return () => {
  //   //   clearTimeout(handler);
  //   // };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPageVal]);

  const onSortModelChange = React.useCallback((sortModel: GridSortModel) => {
    if (currentPage !== 0) {
      setCurrentPageVal(0);
      dispatch(changePageAction(0));
      dispatch(sortKpimetricGridAction(sortModel));
    } else {
      dispatch(sortKpimetricGridAction(sortModel));
    }

    // dispatch(filterTotalFlagAction(true));
  }, []);

  const getRowClassName = useCallback((params: GridRowClassNameParams) => {
    if (params.row.label && params.row.label.includes('cancelled')) return 'Mui-disabled';
    return params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd';
  }, []);

  const [filterButtonEl, setFilterButtonEl] = React.useState<HTMLButtonElement | null>(null);

  const dataTableProps: Omit<DataGridProProps, 'columns'> = {
    rows: dashboardKpiGridData?.orders?.datas ?? [],
    // onSortModelChange,
    //  columnVisibilityModel,
    apiRef,
    autoHeight: false,
    pagination: true,
    // disableColumnMenu: true,
    headerHeight: 100,
    rowHeight: 80,
    onPageSizeChange,
    // pageSize: state.pageSize,
    page: currentPageVal,
    paginationMode: 'server',
    sortingMode: 'server',
    keepNonExistentRowsSelected: true,
    disableSelectionOnClick: true,
    // rowCount: state.totalItems,
    // selectionModel: state.selectedDeliverablesModel,
    onPageChange,
    onSortModelChange,
    // onSelectionModelChange,
    getRowClassName,
    // onColumnOrderChange,
    // checkboxSelection: !state.selectedAllDeliverables, // TODO ignore unselect or select after a select all
    checkboxSelection: false,
  };

  const CustomPagination = ({ showDownload, onDownloadXlsx, ...paginationProps }: any) => (
    <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative', zIndex: 10 }}>
      {showDownload && onDownloadXlsx && (
        <Tooltip title={metricTooltip}>
          <Button
            onClick={onDownloadXlsx}
            variant="contained"
            startIcon={<DownloadIcon />}
            sx={{
              textTransform: 'none',
              borderRadius: 2, // pill-like
              px: 2.5,
              py: 0.8,
              minWidth: 'fit-content',
              boxShadow: 'none',
            }}
          >
            Export excel report
          </Button>
        </Tooltip>
      )}

      <GridPagination {...paginationProps} />
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          height: '70vh',
          overflow: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {FilterKpiMetric?.page_title && (
          <DataGridPro
            //   initialState={{
            //     pinnedColumns: { left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'id', 'tags', 'workunit_name'] },
            //   }}
            columns={dataGridColumns}
            components={{
              // Toolbar: CustomToolbar,
              LoadingOverlay: LinearProgress,
              Pagination: (props) => (
                <CustomPagination {...props} showDownload={showDownload} onDownloadXlsx={onDownloadXlsx} />
              ),
            }}
            componentsProps={{
              loadingOverlay: { style: { zIndex: 9999 } },
              panel: {
                anchorEl: filterButtonEl,
                placement: 'bottom-end',
              },
              toolbar: {
                setFilterButtonEl,
              },
            }}
            loading={loadingProp}
            // className={selectedBLAllDeliverables ? 'test' : 'test'}
            {...dataTableProps}
            apiRef={apiRef}
            rowsPerPageOptions={[10, 25, 50, 100, 200]}
            // page={currentPageVal}
            pageSize={pageSize}
            rowCount={totalItems}
            sx={{
              '& .Mui-disabled': {
                background: '#e1e5ef',
                opacity: '.9',
                pointerEvents: 'initial',
              },
              overflow: 'auto',
              mb: { xs: 30, md: 5 },
            }}
          />
        )}
      </Box>
    </>
  );
};

export default KpiMetricsTable;
